const breakpoints = {
  largest: '75em',
  large: '50em',
  medium: '31.25em',
  small: '22.5em',
};

export default breakpoints;
